import * as z from 'zod';

import { zodDateOrString } from '../utils';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UpdateLoanBoardedDatesEvent = BaseLoanEvent.extend({
  type: z.literal('updateLoanBoardedDates'),
  fundingDate: zodDateOrString,
  firstPaymentDate: zodDateOrString,
  firstCollectedPaymentDate: zodDateOrString,
  annualInterestRate: z.coerce.number().nonnegative().optional(),
  maturityDate: zodDateOrString,
  loanClosingDate: zodDateOrString.optional(),
  currentOutstandingAmount: z.number(),
});
export type UpdateLoanBoardedDatesEvent = z.infer<typeof UpdateLoanBoardedDatesEvent>;
